import styled from 'styled-components';

const ListHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

export default ListHeader;
